import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # LoadingStore
 * - 로딩 상태를 관리하는 스토어
 */
export const LoadingStore = types
  .model('LoadingStore')
  // --------------------------------------------------------------------------
  .props({
    loading: types.optional(types.boolean, false),
    loadingCount: types.optional(types.number, 0), // T023: Counter-based loading state
    message: types.optional(types.string, ''),
  })
  .views((self) => ({
    // T026: isLoading computed property - returns true when loadingCount > 0
    get isLoading() {
      return self.loadingCount > 0;
    },
  }))
  .actions((self) => {
    /**
     * Increment the loading counter by 1.
     * Call this when an API request starts.
     * The loading indicator will show when counter > 0.
     */
    const increaseLoading = () => {
      self.loadingCount += 1;
    };

    /**
     * Decrement the loading counter by 1.
     * Call this when an API request completes (success or error).
     * The counter will never go below 0 (zero floor applied).
     */
    const decreaseLoading = () => {
      self.loadingCount = Math.max(0, self.loadingCount - 1);
    };

    /**
     * T027: @deprecated - maintained for backward compatibility
     * @deprecated Use increaseLoading() and decreaseLoading() instead
     */
    const setLoading = (loading: boolean, message?: string) => {
      // T028: Backward compatibility maintained
      if (loading) {
        increaseLoading();
      } else {
        decreaseLoading();
      }
      self.message = message || '';
    };

    return {
      increaseLoading,
      decreaseLoading,
      setLoading,
    };
  });
// --------------------------------------------------------------------------

// --------------------------------------------------------------------------
type TLoadingStore = Instance<typeof LoadingStore>;
type TLoadingStoreSnapshot = SnapshotOut<typeof LoadingStore>;

export interface ILoadingStore extends TLoadingStore {}
export type TLoadingStoreKeys = keyof TLoadingStoreSnapshot & string;
export interface ILoadingStoreSnapshot extends TLoadingStoreSnapshot {}
export const createLoadingStore = () => types.optional(LoadingStore, {} as TLoadingStore);
